var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_AXIOS_ERROR, SET_AXIOS_READY, SET_TOKEN } from "../actions/axios";
import { TokenType } from "../../interfaces/store/reducers/axios";
var initialState = {
    ready: false,
    error: null,
    tokens: {},
    tokensTypeMap: {},
};
var axiosReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_AXIOS_READY:
            return __assign(__assign({}, state), { ready: true });
        case SET_AXIOS_ERROR:
            return __assign(__assign({}, state), { error: action.payload });
        case SET_TOKEN:
            var _a = action.payload, tokenKey = _a.tokenKey, token = _a.token, _b = _a.tokenType, tokenType = _b === void 0 ? TokenType.TASK : _b;
            var tokenToSet = {};
            var tokenTypeMapToSet = {};
            tokenToSet[tokenKey] = token;
            tokenTypeMapToSet[token] = tokenType;
            return __assign(__assign({}, state), { tokens: __assign(__assign({}, state.tokens), tokenToSet), tokensTypeMap: __assign(__assign({}, state.tokensTypeMap), tokenTypeMapToSet) });
        default:
            return state;
    }
};
export default axiosReducer;
